import { StorefrontApiError } from './api';

export function checkoutLinePieces(input: {
  seriesCount: number;
  seriesQuantity: number;
  extraQuantity: number;
}): number {
  return input.seriesCount * input.seriesQuantity + input.extraQuantity;
}

export function normalizeCheckoutText(value: string): string {
  return value.normalize('NFKC').replace(/\s+/gu, ' ').trim();
}

export function checkoutErrorMessage(error: unknown): string {
  if (!(error instanceof StorefrontApiError)) {
    return 'Sipariş gönderilemedi. Bağlantınızı kontrol edip yeniden deneyin.';
  }
  switch (error.code) {
    case 'ORDER_INTAKE_KEY_REQUIRED':
      return 'Firmanın sipariş kanalı henüz hazır değil. Firma paneli yenilendikten sonra tekrar kontrol edin.';
    case 'STOREFRONT_ORDER_CATALOG_CONFLICT':
      return 'Ürün bilgileri güncellendi. Sayfayı yenileyip sepeti tekrar oluşturun.';
    case 'BUYER_SESSION_REQUIRED':
      return 'Oturumunuz sona erdi. Yeniden giriş yapıp siparişi tekrar gönderin.';
    case 'CATALOG_KEY_GRANT_REQUIRED':
      return 'Bu tarayıcının mağaza erişimi firma onayı bekliyor.';
    case 'INVALID_STOREFRONT_ORDER':
      return 'Sipariş bilgileri doğrulanamadı. Sepeti kontrol edip yeniden deneyin.';
    default:
      return 'Sipariş gönderilemedi. Biraz sonra yeniden deneyin.';
  }
}
